import Modal from './confirm'
let modalInstance
function getModalInstance (options) {
  if (options) {
    options.closable = false
    options.maskClosable = false
    options.footerHide = true
  }
  modalInstance = modalInstance || Modal.newInstance(options)
  return modalInstance
}
function confirm (options) {
  options.onRemove = function () {
    modalInstance = null
  }
  let instance = getModalInstance(options)
  instance.show()
}
Modal.info = function (props = {}) {
  props.icon = 'info'
  props.showCancel = false
  return confirm(props)
}
Modal.success = function (props = {}) {
  props.icon = 'success'
  props.showCancel = false
  return confirm(props)
}
Modal.warning = function (props = {}) {
  props.icon = 'warning'
  props.showCancel = false
  return confirm(props)
}
Modal.error = function (props = {}) {
  props.icon = 'error'
  props.showCancel = false
  return confirm(props)
}
Modal.confirm = function (props = {}) {
  props.icon = 'confirm'
  props.showCancel = true
  return confirm(props)
}
Modal.remove = function () {
  if (!modalInstance) { // at loading status, remove after Cancel
    return false
  }
  const instance = getModalInstance()
  instance.remove()
}
export default Modal



// WEBPACK FOOTER //
// ./src/components/modal/index.js